import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 236px;\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { format, isValid } from 'date-fns/fp';
import { layout } from 'styled-system';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { DateTimePicker } from '../date/DateTimePicker';
import { Icon } from '../icon/Icon';
import { Input } from './Input';
import { themeGet } from '@styled-system/theme-get';
var Wrapper = styled.div(_templateObject(), layout);
var DateTimePickerWrapper = styled.div(_templateObject2(), themeGet('dateInput.backgroundColor'), themeGet('dateInput.border'), themeGet('dateInput.borderRadius'), themeGet('dateInput.boxShadow'), themeGet('dateInput.zIndex'));

var Popover = function Popover(_ref) {
  var children = _ref.children,
      visible = _ref.visible,
      onClose = _ref.onClose;
  var popoverRef = useRef(null);
  var handleBackDropClick = useCallback(function (event) {
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      onClose(event);
    }
  }, [onClose]);
  useEffect(function () {
    document.addEventListener('mousedown', handleBackDropClick);
    return function () {
      document.removeEventListener('mousedown', handleBackDropClick);
    };
  }, [handleBackDropClick]);
  return (
    /*#__PURE__*/
    React.createElement("div", {
      ref: popoverRef
    }, visible && children)
  );
};

export var DateInput = function DateInput(_ref2) {
  var value = _ref2.value,
      onChange = _ref2.onChange,
      minDate = _ref2.minDate,
      maxDate = _ref2.maxDate,
      defaultValue = _ref2.defaultValue,
      disabled = _ref2.disabled,
      required = _ref2.required,
      precision = _ref2.precision,
      showTimePicker = _ref2.showTimePicker,
      showActionsBar = _ref2.showActionsBar,
      canClearSelection = _ref2.canClearSelection,
      dateFormat = _ref2.dateFormat,
      isMobile = _ref2.isMobile,
      width = _ref2.width,
      _ref2$closeOnChange = _ref2.closeOnChange,
      closeOnChange = _ref2$closeOnChange === void 0 ? true : _ref2$closeOnChange,
      restProps = _objectWithoutProperties(_ref2, ["value", "onChange", "minDate", "maxDate", "defaultValue", "disabled", "required", "precision", "showTimePicker", "showActionsBar", "canClearSelection", "dateFormat", "isMobile", "width", "closeOnChange"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = useState(value || defaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      currentValue = _useState4[0],
      setCurrentValue = _useState4[1];

  var inputValue = isValid(currentValue) ? format(dateFormat, currentValue) : '';
  var handleChange = useCallback(function (event) {
    if (onChange) {
      onChange(event);
    }

    if (value === undefined) {
      setCurrentValue(event.target.value);
    }

    if (closeOnChange) {
      setVisible(false);
    }
  }, [closeOnChange, onChange, value]);
  useEffect(function () {
    if (value !== undefined && value !== currentValue) {
      setCurrentValue(value);
    }
  }, [currentValue, value]);
  return (
    /*#__PURE__*/
    React.createElement(Wrapper, {
      width: width
    },
    /*#__PURE__*/
    React.createElement(Input, _extends({}, restProps, {
      width: width,
      value: inputValue,
      onFocus: useCallback(function () {
        return !disabled && setVisible(true);
      }, [disabled]),
      placeholder: dateFormat,
      suffix:
      /*#__PURE__*/
      React.createElement(Icon, {
        name: "CALENDAR"
      }),
      disabled: disabled,
      readOnly: true
    })),
    /*#__PURE__*/
    React.createElement(Popover, {
      visible: visible,
      onClose: useCallback(function () {
        return setVisible(false);
      }, [])
    },
    /*#__PURE__*/
    React.createElement(DateTimePickerWrapper, null,
    /*#__PURE__*/
    React.createElement(DateTimePicker, {
      value: currentValue,
      onChange: handleChange,
      minDate: minDate,
      maxDate: maxDate,
      required: required,
      precision: precision,
      canClearSelection: canClearSelection,
      showTimePicker: showTimePicker,
      showActionsBar: showActionsBar,
      isMobile: isMobile
    }))))
  );
};
DateInput.defaultProps = {
  defaultValue: null,
  dateFormat: 'yyyy-MM-dd',
  showTimePicker: false,
  showActionsBar: true
};